import client from '../client'

export const getMaxMileageKey = `${process.env.NEXT_PUBLIC_SEARCH_DOMAIN}/api/Search/GetMaxMileage`

export async function getMaxMileage() {
  return client(getMaxMileageKey)
}
